module.exports = __webpack_public_path__ + "static/classhook-clipview-after-eb5e71d5efcd59b0469ef8f3e42f31a0.jpg";